<template>
    <div class="login">
        <div class="loginDialog">
            <!--      <div class="loginDialog" :style="{height:ifLoginRoRegister=='Y'?'720px':'770px',background:ifLoginRoRegister=='Y'?'url('+loginURL+') 100% 100% no-repeat':'url('+registerURL+') 100% 100% no-repeat'}">-->
            <div class="loginForm">
                <!--        <img style="cursor:pointer;" class="closeClass" @click="closeLoginDialog()" src="@/assets/images/new_lo_close.png" />-->
                <div class="contentClass" :style="{height:ifLoginRoRegister=='Y'?'586px':'656px',borderRadius:'10px' }">
                    <img style="cursor:pointer;" class="closeClass" @click="closeLoginDialog()"
                         src="@/assets/images/new_lo_close.png" alt='版权登记'/>
                    <Row style="margin-top:22px" type="flex" justify="center" align="middle"
                         @keydown.enter.native="submitLogin" v-if="checkTabFlag">
                        <Col style="width: 368px;">
                            <Row>
                                <Tabs v-model="tabName" @on-click="changeTabs">
                                    <TabPane :label="$t('usernameLogin')" name="username">
                                        <Form
                                                ref="usernameLoginForm"
                                                :model="form"
                                                :rules="rules"
                                                class="form"
                                                v-if="tabName=='username'"
                                        >
                                            <FormItem class="loginInput" prop="username">
                                                <div class="logincom">
                                                    <div class="loginlabel">手机号：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.username"
                                                            maxlength="11"
                                                            placeholder="请输入手机号"
                                                            autocomplete="off"
                                                            @on-blur="checkRegister('userName')"
                                                            @on-change="ver_disabled = 'none' "
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem class="loginInput" prop="imgCode">
                                              <div class="logincom" style="display: flex; align-items: center;">
                                                <div class="loginlabel">图形码：</div>
                                                  <Input style="width: 256px !important; display: inline-block;"
                                                          v-model="form.imgCode"
                                                          clearable
                                                          placeholder="请输入图片验证码"
                                                          :maxlength="10"
                                                  />
                                                  <div style="position:relative">
                                                      <Spin v-if="loadingCaptcha" fix></Spin>
                                                      <img
                                                              :src="captchaImg"
                                                              @click="getCaptchaImg"
                                                              alt="加载验证码失败"
                                                              style="width:100px;cursor:pointer;display:block;
                                                              margin-left: 10px"
                                                      />
                                                  </div>
                                              </div>
                                            </FormItem>
                                            <FormItem class="loginInput" prop="verifyCode">
                                                <div class="logincom">
                                                    <div class="loginlabel">验证码：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.verifyCode"
                                                            placeholder="请输入验证码"
                                                            autocomplete="off"
                                                    />
<!--                                                    <div @click="_postLoginSendSmsCode('4')" class="loginVertial"-->
<!--                                                         :style="{pointerEvents:ver_disabled}">{{verifyCode_time}}-->
<!--                                                    </div>-->
                                                    <input  v-if="verifyCode_time >=0 && verifyCode_time <=60"  v-model="countdown" type="button"  class="loginVertial" />
                                                    <input  v-else type="button" @click.prevent="_postLoginSendSmsCode('4')" class="loginVertial" v-model="verifyCode_time">

                                                </div>
                                            </FormItem>
                                            <FormItem class="loginInput" prop="inviteCode"
                                                      style="margin-bottom:15px;visibility: hidden;">
                                                <div class="logincom">
                                                    <div class="loginlabel">邀请码：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.inviteCode"
                                                            placeholder="好友邀请码（非必填）"
                                                            autocomplete="off"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem>
                                                <div class="fuxy">
                                                    <img @click="checkchdata()" :src="checkboxmn=='Y'?ye:noye" alt='版权登记'/>
                                                    <p>阅读并同意</p>
                                                    <a @click="lawLink">《注册协议及隐私协议》</a>
                                                    <p @click="goRegister()" style="cursor:pointer;margin-left: auto;"
                                                       class="goRegister">注册账号</p>

                                                </div>
                                            </FormItem>
                                        </Form>
                                    </TabPane>
                                    <TabPane :label="$t('mobileLogin')" name="mobile">
                                        <Form
                                                ref="mobileLoginForm"
                                                :model="form"
                                                :rules="rules"
                                                class="form"
                                                v-if="tabName=='mobile'"
                                        >
                                            <FormItem v-if="ifLoginRoRegister=='Y'" class="loginInput" prop="username">
                                                <div class="logincom">
                                                    <div class="loginlabel">用户名：</div>
                                                    <Input
                                                            v-model="form.username"
                                                            placeholder="请输入手机号或邮箱"
                                                            autocomplete="off"
                                                            @on-blur="checkRegister('phoneEmail')"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='Y'" class="loginInput"
                                                      prop="passwordOld">
                                                <div class="logincom">
                                                    <div class="loginlabel">密码：</div>
                                                    <Input
                                                            type="password"
                                                            v-model="form.passwordOld"
                                                            placeholder="请输入密码"
                                                            autocomplete="off"
                                                    />
<!--                                                    <div @click="forgetPwdAction" class="loginVertial">忘记密码</div>-->
                                                </div>
                                                <!-- <Row type="flex" justify="space-between">
                                                  <Input
                                                    v-model="form.code"
                                                    prefix="ios-mail-outline"
                                                    size="large"
                                                    clearable
                                                    placeholder="请输入短信验证码"
                                                    :maxlength="4"
                                                    class="input-verify"
                                                  />
                                                  <CountDownButton
                                                    ref="countDown"
                                                    @on-click="sendSmsCode"
                                                    :autoCountDown="false"
                                                    size="large"
                                                    :loading="sending"
                                                    :text="getSms"
                                                  />
                                                </Row> -->
                                            </FormItem>

                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput"
                                                      prop="mobilePhone">
                                                <div class="logincom">
                                                    <div class="loginlabel">手机号：</div>
                                                    <Input
                                                            type="text"
                                                            maxlength="11"
                                                            v-model="form.mobilePhone"
                                                            placeholder="请输入手机号"
                                                            autocomplete="off"
                                                            @on-blur="checkRegister('mobilePhone')"
                                                            @on-change="ver_disabled = 'none' "
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem class="loginInput" prop="imgCode">
                                              <div class="logincom" style="display: flex; align-items: center;">
                                                  <div class="loginlabel">图形码：</div>
                                                    <Input style="width: 256px !important; display: inline-block;"
                                                            v-model="form.imgCode"
                                                            clearable
                                                            placeholder="请输入图片验证码"
                                                            :maxlength="10"
                                                    />
                                                    <div style="position:relative;">
                                                        <Spin v-if="loadingCaptcha" fix></Spin>
                                                        <img
                                                                :src="captchaImg"
                                                                @click="getCaptchaImg"
                                                                alt="加载验证码失败"
                                                                style="width:100px;cursor:pointer;display:block;
                                                                margin-left: 10px"
                                                        />
                                                    </div>
                                              </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='Y'" class="loginInput" prop="inviteCode"
                                                      style="margin-bottom:15px;visibility: hidden;">
                                                <div class="logincom">
                                                    <div class="loginlabel">邀请码：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.inviteCode"
                                                            placeholder="好友邀请码（非必填）"
                                                            autocomplete="off"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput"
                                                      prop="verifyCode">
                                                <div class="logincom">
                                                    <div class="loginlabel">验证码：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.verifyCode"
                                                            placeholder="请输入验证码"
                                                            autocomplete="off"
                                                    />
<!--                                                    <div @click="_postLoginSendSmsCode('1')" class="loginVertial"-->
<!--                                                         :style="{pointerEvents:ver_disabled}">{{verifyCode_time}}-->
<!--                                                    </div>-->
                                                    <input  v-if="verifyCode_time >=0 && verifyCode_time <=60"  v-model="countdown" type="button"  class="loginVertial" />
                                                    <input  v-else type="button" @click.prevent="_postLoginSendSmsCode('1')" class="loginVertial"  v-model="verifyCode_time" >

                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="password" style="margin-bottom:33px">
                                                <div class="logincom">
                                                    <div class="loginlabel">密码：</div>
                                                    <Input
                                                            type="password"
                                                            v-model="form.password"
                                                            placeholder="请输入密码"
                                                            autocomplete="off"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput"
                                                      prop="nextPassword">
                                                <div class="logincom">
                                                    <div class="loginlabel" style="width:70px;margin-right:0px">确认密码：
                                                    </div>
                                                    <Input
                                                            type="password"
                                                            v-model="form.nextPassword"
                                                            placeholder="请确认密码"
                                                            autocomplete="off"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem v-if="ifLoginRoRegister=='N'" class="loginInput" prop="inviteCode"
                                                      style="visibility: hidden;">
                                                <div class="logincom">
                                                    <div class="loginlabel">邀请码：</div>
                                                    <Input
                                                            type="text"
                                                            v-model="form.inviteCode"
                                                            placeholder="好友邀请码(非必填)"
                                                            autocomplete="off"
                                                    />
                                                </div>
                                            </FormItem>
                                            <FormItem>
                                                <div style="display:flex;justify-content:space-between">
                                                    <p v-if="ifLoginRoRegister=='Y'" @click="forgetPwdAction"
                                                       style="cursor:pointer;" class="goRegister">忘记密码</p>
                                                    <p v-if="ifLoginRoRegister=='Y'" @click="goRegister()"
                                                       style="cursor:pointer;" class="goRegister">注册账号</p>
                                                    <p v-if="ifLoginRoRegister=='N'" @click="goLogin()"
                                                       style="width:28px;cursor:pointer;margin-left: auto" class="goRegister">登录</p>
                                                </div>
                                            </FormItem>
                                        </Form>
                                    </TabPane>
                                </Tabs>
                                <Row>

                                    <div :style="{marginTop:ifLoginRoRegister=='Y'?'90px':'4px'}">
                                        <div v-if="tabName == 'mobile' " class="fuxy" style="margin-top: -30px;margin-bottom: 10px;">
                                            <img @click="checkchdata()" :src="checkboxmn=='Y'?ye:noye" alt='版权登记'/>
                                            <p>阅读并同意</p>
                                            <a @click="lawLink">《注册协议及隐私协议》</a>
                                        </div>
                                        <Button
                                                class="login-btn"
                                                type="primary"
                                                size="large"
                                                :disabled="isDisable"
                                                :loading="loading"
                                                @click="submitLogin"
                                                long
                                        >
                                            <span v-if="!loading">{{ ifLoginRoRegister=='Y'?$t('login'):'注册' }}</span>
                                            <span v-else>{{ $t('logining') }}</span>
                                        </Button>

                                    </div>
                                </Row>
                                <!-- <Row type="flex" justify="space-between" class="other-login">
                                  <div class="other-way icons">
                                    {{ $t('otherLogin') }}
                                    <div class="other-icon" @click="toGithubLogin">
                                      <icon scale="1.1" name="brands/github"></icon>
                                    </div>
                                    <div class="other-icon" @click="toQQLogin">
                                      <icon name="brands/qq"></icon>
                                    </div>
                                    <div class="other-icon" @click="toWeiboLogin">
                                      <icon scale="1.2" name="brands/weibo"></icon>
                                    </div>
                                    <div class="other-icon" @click="toWeixinLogin">
                                      <icon scale="1.2" name="brands/weixin"></icon>
                                    </div>
                                  </div>
                                  <router-link to="/regist">
                                    <a class="forget-pass">{{ $t('regist') }}</a>
                                  </router-link>
                                </Row> -->


<!--                                <Row type="flex" justify="space-between" class="other-login">
                                    <div class="lo_three" style="">
                                        <div class="lo_weixin" @click="otherLogin(0)"></div>
                                        <div class="lo_qq" @click="otherLogin(1)"></div>
                                        <div class="lo_weibo" @click="otherLogin(2)"></div>
                                    </div>
                                    <p>未注册的手机号或第三方账号验证后将自动创建新账号</p>
                                </Row>-->
                            </Row>
                        </Col>
                        <!-- <LangSwitch /> -->
                    </Row>

                    <Row style="margin-top:22px" type="flex" justify="center" align="middle"
                         @keydown.enter.native="submitLogin" v-else>
                        <Col style="width: 368px;">
                            <Row>
                               <div class="forgetStyle">忘记密码</div>
                                <Form
                                    ref="mobileUpdateForm"
                                    :model="form"
                                    :rules="rules"
                                    class="form"
                                >
                                <FormItem class="loginInput" prop="username">
                                    <div class="logincom">
                                        <div class="loginlabel">用户名：</div>
                                        <Input
                                            v-model="form.username"
                                            placeholder="请输入手机号或邮箱"
                                            autocomplete="off"
                                            @on-blur="checkRegisterNumEmail()"
                                        />
                                    </div>
                                </FormItem>
                                <FormItem class="loginInput" prop="imgCode">
                                  <div class="logincom" style="display: flex; align-items: center;">
                                    <div class="loginlabel">图形码：</div>
                                    <Input style="width: 256px !important; display: inline-block;"
                                            v-model="form.imgCode"
                                            clearable
                                            placeholder="请输入图片验证码"
                                            :maxlength="10"
                                            class="input-verify"
                                    />
                                    <div style="position:relative">
                                        <Spin v-if="loadingCaptcha" fix></Spin>
                                        <img
                                                :src="captchaImg"
                                                @click="getCaptchaImg"
                                                alt="加载验证码失败"
                                                style="width:100px;cursor:pointer;display:block;
                                                margin-left: 10px"
                                        />
                                    </div>
                                  </div>
                                </FormItem>
                                <FormItem class="loginInput"
                                            prop="verifyCode">
                                    <div class="logincom">
                                        <div class="loginlabel">验证码：</div>
                                        <Input
                                                type="text"
                                                v-model="form.verifyCode"
                                                placeholder="请输入验证码"
                                                autocomplete="off"
                                        />
                                        <input  v-if="verifyCode_time >=0 && verifyCode_time <=60"  v-model="countdown" type="button"  class="loginVertial" />
                                        <input  v-else type="button" @click.prevent="SendNumCode()" class="loginVertial"  v-model="verifyCode_time" >

                                        <!--                                        <div @click="SendNumCode()" class="loginVertial"-->
<!--                                                :style="{pointerEvents:ver_disabled}">{{verifyCode_time}}-->
<!--                                        </div>-->
                                    </div>
                                </FormItem>
                                <FormItem class="loginInput" prop="password" style="margin-bottom:33px">
                                    <div class="logincom">
                                        <div class="loginlabel">密码：</div>
                                        <Input
                                                type="password"
                                                v-model="form.password"
                                                placeholder="请输入密码"
                                                autocomplete="off"
                                        />
                                    </div>
                                </FormItem>
                                <FormItem class="loginInput"
                                            prop="nextPassword">
                                    <div class="logincom">
                                        <div class="loginlabel" style="width:70px;margin-right:0px">确认密码：
                                        </div>
                                        <Input
                                                type="password"
                                                v-model="form.nextPassword"
                                                placeholder="请确认密码"
                                                autocomplete="off"
                                        />
                                    </div>
                                </FormItem>
                                <FormItem>
                                    <div style="display:flex;justify-content:flex-end">
                                        <p @click="goLogin(0)" style="width:28px;cursor:pointer;" class="goRegister">登录</p>
                                    </div>
                                </FormItem>
                                </Form>
                            </Row>
                            <Row>
                                <Button
                                        style="marginTop:4px"
                                        class="login-btn"
                                        type="primary"
                                        size="large"
                                        @click="submitUpdate"
                                        long
                                >
                                    <span>确认</span>
                                </Button>
                            </Row>
                        </Col>
                    </Row>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {login, userInfo, initCaptcha, drawCodeImage,_forgetPassword,regist} from "@/api/index";
    import {bqjUrl} from "@/config/config"

    import {postLoginSendSmsCode, postThroughDynamicCode, getCheckRegister,postEmailCode} from "@/api/staticPage";
    import {validateMobile, validatePassword} from "@/libs/validate";
    import Cookies from "js-cookie";
    import Header from "@/views/main-components/header";
    import Footer from "@/views/main-components/footer";
    import LangSwitch from "@/views/main-components/lang-switch";
    import CountDownButton from "@/views/my-components/xboot/count-down-button";
    import util from "@/libs/util.js";
    import EventBus from "@/libs/eventBus"
    import {_countOrder} from "@/api/wallet.js";
    export default {
        name: 'login',
        components: {
            CountDownButton,
            LangSwitch,
            Header,
            Footer
        },
        data() {
            return {
                orBtn: 0,
                captchaId: "",
                captchaImg: "",
                loadingCaptcha: true,
                error: false,
                tabName: "username",
                saveLogin: false,
                getSms: "获取验证码",
                ifLoginRoRegister: 'Y',
                loading: false,
                sending: false,
                errorCode: "",
                verifyCode_time: '获取验证码',
                ver_disabled: 'auto',
                ver_msg: '', //手机判断验证
                ifRegister: '',
                checkTabFlag:true,//切换整体tab
                vertifyCodeType: '1', //获取验证码类型 1：手机号 0：邮箱
                isDisable:false,
                form: {
                    username: "",
                    imgCode: "",
                    passwordOld: "",
                    password: "",
                    mobile: "",
                    verifyCode: '',
                    inviteCode: "",
                    code: "",
                    nextPassword: "",
                    mobilePhone: "",
                },
                checkboxmn: 'Y',
                ye: require('../assets/images/new_lo_ye.png'),
                noye: require('../assets/images/new_lo_hu.png'),
                loginURL: require('../assets/images/new_lo_background.png'),
                registerURL: require('../assets/images/new_lo_regbackground.png'),
                rules: {
                    username: [
                        {
                            required: true,
                            message: "账号不能为空",
                            trigger: "blur"
                        }
                    ],
                    verifyCode: [
                        {
                            required: true,
                            message: "验证码不能为空",
                            trigger: "blur"
                        }
                    ],
                    passwordOld: [
                        {
                            required: true,
                            message: "密码不能为空",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "密码不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validatePassword,
                            trigger: "blur"
                        }
                    ],
                    nextPassword: [
                        {
                            required: true,
                            message: "确认密码不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validatePassword,
                            trigger: "blur"
                        }
                    ],
                    imgCode: [
                        {
                            required: true,
                            message: "验证码不能为空",
                            trigger: "blur"
                        }
                    ],
                    mobile: [
                        {
                            required: true,
                            message: "手机号不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur"
                        }
                    ],
                    mobilePhone: [
                        {
                            required: true,
                            message: "手机号不能为空",
                            trigger: "blur"
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur"
                        }
                    ]
                }
            };
        },
        computed:{
            'countdown':function () {
                if(this.verifyCode_time >=0 && this.verifyCode_time<=60)
                {
                    return this.verifyCode_time + "s"
                }
            }
        },
        methods: {
            //ucenter通信
            callChild(jscode){

                // 传参并指定回调执行函数为onBack
                for(let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
                // let ifr = document.getElementById('main_login');
                // ifr.style.display = 'none';
                // setTimeout(function(){ top.location.reload(); }, 1000);
            },
            //忘记密码切换框
            forgetPwdAction(){
                this.checkTabFlag=false
            },
            lawLink() {
                window.open('/instrument/2', '_blank')
                // this.$router.push({name:'instrument',params: {id:1}})
            },
            checkRegister(strphoto) {
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (strphoto == 'userName') {
                    if (!myreg.test(this.form.username)) {
                        toast('手机号格式不正确')
                        return false;
                    } else {
                        console.log('手机号格式正确')
                    }
                } else if (strphoto == 'phoneEmail') {
                    var emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                    if (!myreg.test(this.form.username) && !emailReg.test(this.form.username)) {
                        toast('用户名格式错误');
                        return false;
                    } else {
                        console.log('用户名格式正确')
                    }
                } else {
                    if (!myreg.test(this.form.mobilePhone)) {
                        toast('手机号格式不正确')
                        return false;
                    } else {
                        console.log('手机号格式正确')
                    }
                }
                getCheckRegister({username: strphoto == 'userName' || strphoto == 'phoneEmail' ? this.form.username : this.form.mobilePhone}).then((res) => {
                    console.log(res)
                    if (res.code == 202) {
                        this.ifRegister == 'N'
                        if (strphoto == 'userName' || strphoto == 'phoneEmail') {
                            toast('该账号未注册')
                            this.ver_disabled = 'none'
                            this.ver_msg = '该账号未注册'
                            this.orBtn = 1
                        } else if (this.ifLoginRoRegister == 'Y' && strphoto == 'mobile') {
                            toast('该账号未注册')
                            this.ver_disabled = 'none'
                            this.ver_msg = '该账号未注册'
                        } else {
                            this.ver_disabled = 'auto'
                            this.ver_msg = ''
                        }
                    } else {
                        this.ifRegister == 'Y'
                        this.orBtn = 0
                        if (strphoto == 'userName' || strphoto == 'phoneEmail') {
                            this.ver_disabled = 'auto'
                            this.ver_msg = ''
                        } else {
                            toast('该账户已注册！')
                            this.ver_msg = '该账户已注册'
                            this.ver_disabled = 'none'
                        }
                    }
                })
            },
            //判断用户名
            checkRegisterNumEmail(){
                let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                if (!myreg.test(this.form.username) && !emailReg.test(this.form.username)) {
                    toast('请填写正确的手机号或邮箱');
                    return false;
                }
                 if(myreg.test(this.form.username)){
                    this.vertifyCodeType=1
                 }else if(emailReg.test(this.form.username)){
                    this.vertifyCodeType=0
                 }
                getCheckRegister({username: this.form.username}).then((res) => {
                    if (res.code == 202) {
                        toast('该账号未注册')
                        this.ver_disabled = 'none'
                        this.ver_msg = '该账号未注册'
                    } else {
                        this.ver_disabled = 'auto'
                        this.ver_msg = ''
                    }
                })
            },
            _postLoginSendSmsCode(type) {
                console.log('进入');
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let params;
                let _this = this
                if (type == 1) {
                    if (this.form.mobilePhone == '') {
                        return false;
                    } else if (!myreg.test(this.form.mobilePhone)) {
                        toast('手机号格式不正确')
                        return false;
                    } else if(this.form.imgCode ==""){
                        toast('图形验证码为空')
                        return false;
                    }else{
                        console.log('手机号格式正确')
                        params = {
                            mobile: this.form.mobilePhone,
                            imageCode:this.form.imgCode,
                            captchaId:this.captchaId,
                            type: type
                        }
                    }
                } else if (type == 4) {
                    if (!myreg.test(this.form.username)) {
                        toast('手机号格式不正确')
                        return false;
                    } else if(this.form.imgCode ==""){
                        toast('图形验证码为空')
                        return false;
                    }else {
                        console.log('手机号格式正确')
                        params = {
                            mobile: this.form.username,
                            imageCode:this.form.imgCode,
                            captchaId:this.captchaId,
                            type: type
                        }
                    }
                } else {

                }

                // 发送验证码的时候，判断一下手机验证信息是否错误
                if(this.ver_msg){
                    toast(this.ver_msg)
                    return false;
                }


                postLoginSendSmsCode(params).then(res => {
                    console.log('发送验证码成功', res)
                    if (res.code == 200) {
                        this.verifyCode_time = 60
                        this.ver_disabled = 'none'
                        const timer = setInterval(() => {
                            if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                this.verifyCode_time = this.verifyCode_time - 1
                            } else {
                                clearInterval(timer);
                                this.verifyCode_time = '获取验证码'
                                this.ver_disabled = 'auto'
                            }
                        }, 1000)
                    }else{
                      toast(res.message)
                    }

                })
            },
            //修改密码发送验证码
            SendNumCode() {
                let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let params;
                let emailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
                if (!myreg.test(this.form.username) && !emailReg.test(this.form.username)) {
                    toast('请填写正确的手机号或邮箱');
                    return false;
                }else {

                    // 发送验证码的时候，判断一下手机验证信息是否错误
                    if(this.ver_msg){
                        toast(this.ver_msg)
                        return false;
                    }

                    if(this.form.imgCode ==""){
                        toast('请填写图形验证码');
                        return false;
                    }

                    if(myreg.test(this.form.username)){



                        this.vertifyCodeType=1
                        params = {
                            mobile: this.form.username,
                            imageCode:this.form.imgCode,
                            captchaId:this.captchaId,
                            type: 2
                        }
                        postLoginSendSmsCode(params).then(res => {
                            if (res.code == 200) {
                                this.verifyCode_time = 60
                                this.ver_disabled = 'none'
                                const timer = setInterval(() => {
                                    if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                        this.verifyCode_time = this.verifyCode_time - 1
                                    } else {
                                        clearInterval(timer);
                                        this.verifyCode_time = '获取验证码'
                                        this.ver_disabled = 'auto'
                                    }
                                }, 1000)
                            }

                        })
                    }else if(emailReg.test(this.form.username)){
                        this.vertifyCodeType=0
                        params = {
                            email: this.form.username,
                            type: 2
                        }
                        postEmailCode(params).then(res => {
                            if (res.code == 200) {
                                this.verifyCode_time = 60
                                this.ver_disabled = 'none'
                                const timer = setInterval(() => {
                                    if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                        this.verifyCode_time = this.verifyCode_time - 1
                                    } else {
                                        clearInterval(timer);
                                        this.verifyCode_time = '获取验证码'
                                        this.ver_disabled = 'auto'
                                    }
                                }, 1000)
                            }
                        })
                    }
                }
            },
            closeLoginDialog() {
                this.$emit('fatherClose');
            },
            checkchdata() {
                this.checkboxmn = this.checkboxmn == 'Y' ? 'N' : 'Y'
            },
            changeTabs(name) {
                console.log('获取的切换tabs的值', name)
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.code = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.verifyCode_time = '获取验证码';
                if (name == 'username') {
                    this.ifLoginRoRegister = 'Y'
                }
                this.checkboxmn = 'Y'
            },
            goRegister() {
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.code = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.ifLoginRoRegister = 'N'
                this.tabName = 'mobile';
            },
            goLogin(val) {
                if(val==0){
                    this.checkTabFlag=true
                }
                this.form.username = "";
                this.form.password = "";
                this.form.passwordOld = "";
                this.form.mobile = "";
                this.form.verifyCode = '';
                this.form.inviteCode = "";
                this.form.code = "";
                this.form.nextPassword = "";
                this.form.mobilePhone = "";
                this.ifLoginRoRegister = 'Y'
            },
            getCaptchaImg() {
                console.log("加载图形验证码");

                this.loadingCaptcha = true;
                initCaptcha().then(res => {
                    this.loadingCaptcha = false;
                    if (res.success) {
                        this.captchaId = res.result;
                        this.captchaImg = bqjUrl+drawCodeImage + this.captchaId;
                    }
                });
            },
            sendSmsCode() {
                this.$refs.mobileLoginForm.validate(valid => {
                    if (valid) {
                        this.$Modal.info({
                            title: "抱歉，请获取完整版",
                            content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                        });
                    }
                });
            },
            //确认修改密码
            submitUpdate(){
                this.$refs.mobileUpdateForm.validate(valid => {
                    if (valid) {
                        if (this.form.nextPassword !== this.form.password) {
                            toast("两次输入的密码不一致");
                            return false
                        }
                        const data ={
                            username:this.form.username,
                            verifyCode:this.form.verifyCode,
                            password:this.form.password,
                            nextPassword:this.form.nextPassword,
                            isMobilePhone:this.vertifyCodeType
                        }
                        console.log(data)
                        _forgetPassword(data).then(res => {
                            if(res.code==200){
                                toast("修改成功")
                                this.goLogin(0)
                            }else{
                                toast(res.message)
                            }
                        })
                    }
                });
            },
            submitLogin() {
                console.log(this.$route.query.action);
                if (this.tabName == "username") {
                    this.$refs.usernameLoginForm.validate(valid => {
                        if (valid) {
                            var myregsd = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                            if (!myregsd.test(this.form.username)) {
                                toast('手机号格式不正确')
                                return false;
                            } else {
                                console.log('手机号格式正确')
                            }
                            if (this.checkboxmn == 'N') {
                                toast('请勾选并同意注册协议及隐私协议')
                                return false;
                            }
                            this.loading = true;
                            this.isDisable = true ;
                            postThroughDynamicCode({
                                username: this.form.username,
                                verifyCode: this.form.verifyCode,
                            }).then(res => {
                                if (res.success) {
                                    this.setStore("accessToken", res.result);
                                    let jscode = res.javascript;
                                    this.callChild(jscode);
                                    // 获取用户信息
                                    userInfo().then(res => {
                                        console.log("?????????????????????", res)
                                        if (res.code == 200) {
                                            // 避免超过大小限制
                                            if (this.saveLogin) {
                                                // 保存7天
                                                	Cookies.set("userInfo", JSON.stringify(res.result), {
                                                    expires: 7
                                                });
                                            } else {
                                                Cookies.set("userInfo", JSON.stringify(res.result));
                                            }

                                            this.setStore("userInfo", res.result);
                                            let photo = res.result.photo ? res.result.photo : ''
                                            this.$emit('childFn', photo);
                                            this.$store.commit("setAvatarPath", photo);
                                            this.$store.state.app.showPayWay = true

                                            // 加载菜单
                                            util.initRouter(this);
                                            /*this.$router.push({
                                                name: "home_index"
                                            });*/
                                            EventBus.emit("showModalFun", 'aaa');
                                            console.log("登陆成功拉！")
                                            this.closeLoginDialog()
                                            if (this.$route.query.action == 'ipauth') {
                                                let url = `https://ipshouquan.bqj.cn/web/index.html?user=${res.result.account}&password=${res.result.password}`
                                                window.open(url,'_self')
                                            }
                                        } else {
                                            this.loading = false;
                                            this.isDisable = false ;
                                        }
                                    });
                                    //获取是否有未支付的订单
                                    _countOrder().then(res=>{
                                        if(res.code == 200){
                                            Cookies.set("countOrderNum",res.result);
                                            this.setStore("countOrderNum", res.result);
                                        }
                                    })
                                } else {
                                    this.loading = false;
                                    this.isDisable = false ;
                                    // this.getCaptchaImg();
                                    toast(res.message)
                                }
                            });
                        }
                    });
                } else if (this.tabName == "mobile") {
                    this.$refs.mobileLoginForm.validate(valid => {
                        if (valid) {
                            if (this.ifLoginRoRegister == 'Y') {
                                if (this.checkboxmn == 'N') {
                                    toast('请勾选并同意注册协议及隐私协议')
                                    return false;
                                }
                                if (this.orBtn == 1) {
                                    toast("该账号未注册")
                                    return false;
                                } else {
                                    this.isDisable = true ;
                                    login({
                                        username: this.form.username,
                                        password: this.form.passwordOld,
                                    }).then(res => {
                                        if (res.success) {
                                            this.setStore("accessToken", res.result);
                                            let jscode = res.javascript;
                                            this.callChild(jscode);

                                            // 获取用户信息
                                            userInfo().then(res => {
                                                console.log("?????????????????????", res)
                                                if (res.code == 200) {
                                                    // 避免超过大小限制
                                                    if (this.saveLogin) {
                                                        // 保存7天
                                                        Cookies.set("userInfo", JSON.stringify(res.result), {
                                                            expires: 7
                                                        });
                                                    } else {
                                                        Cookies.set("userInfo", JSON.stringify(res.result));
                                                    }
                                                    this.$store.state.app.showPayWay = true
//                                                  console.log(this.$store.state.app.showPayWay)
                                                    this.setStore("userInfo", res.result);
                                                    let photo = res.result.photo ? res.result.photo : ''
                                                    this.$store.commit("setAvatarPath", photo);
                                                    this.$emit('childFn', photo);
                                                    // 加载菜单
                                                    util.initRouter(this);
                                                    /*this.$router.push({
                                                        name: "home_index"
                                                    });*/
                                                    EventBus.emit("showModalFun", 'aaa');
                                                    this.closeLoginDialog()
                                                    if (this.$route.query.action == 'ipauth') {
                                                        let url = `https://ipshouquan.bqj.cn/web/index.html?user=${res.result.account}&password=${res.result.password}`
                                                        window.open(url,'_self')
                                                    }
                                                } else {
                                                    this.loading = false;
                                                    this.isDisable = false ;
                                                }
                                            });
                                            //获取是否有未支付的订单
                                            _countOrder().then(res=>{
                                                if(res.code == 200){
                                                    Cookies.set("countOrderNum",res.result);
                                                    this.setStore("countOrderNum", res.result);
                                                }
                                            })
                                        } else {
                                            this.loading = false;
                                            this.isDisable = false ;
                                            // this.getCaptchaImg();
                                            toast(res.message)
                                        }
                                    });
                                }
                            } else {
                                if (this.checkboxmn == 'N') {
                                    toast('请勾选并同意注册协议及隐私协议')
                                    return false;
                                }
                                this.isDisable = true ;
                                regist(this.form).then(res => {
                                    if (res.code == 200) {
                                        toast('注册成功')
                                        this.setStore("accessToken", res.result);
                                        let jscode = res.javascript;
                                        this.callChild(jscode);

                                        // 获取用户信息
                                        this.ifLoginRoRegister = 'Y'
                                        userInfo().then(res => {
                                            console.log("?????????????????????", res)
                                            if (res.code == 200) {
                                                // 避免超过大小限制
                                                if (this.saveLogin) {
                                                    // 保存7天
                                                    Cookies.set("userInfo", JSON.stringify(res.result), {
                                                        expires: 7
                                                    });
                                                } else {
                                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                                }
                                                this.setStore("userInfo", res.result);
                                                let photo = res.result.photo ? res.result.photo : ''
                                                this.$store.commit("setAvatarPath", photo);
                                                this.$emit('childFn', photo);
                                                this.$store.state.app.showPayWay = true
                                                // 加载菜单
                                                util.initRouter(this);
                                                /*this.$router.push({
                                                    name: "home_index"
                                                });*/
                                                EventBus.emit("showModalFun", 'aaa');
                                                this.closeLoginDialog()
                                                if (this.$route.query.action == 'ipauth') {
                                                    let url = `https://ipshouquan.bqj.cn/web/index.html?user=${res.result.account}&password=${res.result.password}`
                                                    window.open(url,'_self')
                                                }
                                            } else {
                                                this.loading = false;
                                                this.isDisable = false ;
                                            }
                                        });
                                    } else {
                                        this.isDisable = false ;
                                        toast(res.message)
                                    }
                                })
                            }
                            this.form.saveLogin = this.saveLogin;
                        }
                    });
                }
            },
            toGithubLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toQQLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toWeiboLogin() {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            toWeixinLogin() {
                this.$Message.error("开通微信登录官方收费300/年");
            },
            relatedLogin() {
            },
            handleDropDown(v) {
                this.$Modal.info({
                    title: "抱歉，请获取完整版",
                    content: "支付链接: http://xpay.exrick.cn/pay?xboot"
                });
            },
            showAccount() {
                this.$Notice.info({
                    title: "体验账号密码",
                    desc:
                        "账号1：test 密码：123456 <br>账号2：test2 密码：123456 已开放注册！",
                    duration: 10
                });
            },
            /**********三方登录*******/
            otherLogin(index) {
                let API_ROOT_UPLOAD = this.API_ROOT_UPLOAD;
                let protocol = window.location.protocol;
                let host = window.location.host;
                switch (index) {

                    //微信
                    case 0:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weixin/auth?backurl=${protocol}//${host}/index.html`;
                        break;

                    //QQ
                    case 1:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/qq/auth?backurl=${protocol}//${host}/index.html`;
                        break;

                    //微博
                    case 2:
                        window.location.href = `${API_ROOT_UPLOAD}bqjvip/third/weibo/auth?backurl=${protocol}//${host}/index.html`;
                        break;
                }
            }

        },
        mounted() {
            // this.showAccount();
            // this.relatedLogin();
            this.getCaptchaImg();
        }
    };
</script>

<style scoped lang="less">
    @import "./login.less";
</style>
